import { GetServerSidePropsContext } from 'next'

// Example of SSRing with trpc query + session
export async function getServerSideProps(_context: GetServerSidePropsContext<{}>) {
  return {
    redirect: {
      destination: `https://www.paradigm.xyz/2022/09/artgobblers`,
      permanent: false,
    },
  }
}

const MintRedirectPage = () => {
  return null
}

export default MintRedirectPage
